import React, { useState } from "react";
import InputField from "common/customInputField";
import Modal from "common/modal";
import pencil from "svg/pencil.svg";
import { useParams } from "react-router-dom";
import { api } from "store/slices/api";
import { toast } from "react-toastify";
import { calcuateLineItemTotal } from "../../utils";

const tdClass = "table-root-floor__body__tr__td table-root-floor__body__tr__td__text";

const ProductEditModal = ({ productId, productName, quantity, price, isTaxChecked }) => {
  const { quoteId, floorId } = useParams();
  const { data: quotes = {} } = api.useGetPriceQuoteQuery(quoteId);
  const [show, setShow] = useState(false);
  const [updateProduct] = api.useUpdateFloorProductsMutation();
  const [editedFields, setEditedFields] = useState({ productId, productName, quantity, price });

  const handleSave = () => {
    const { price, quantity } = editedFields;
    const totals = calcuateLineItemTotal({ price, quantity, taxRate: isTaxChecked ? quotes.taxRate : 0 });
    toast.promise(updateProduct({ ...editedFields, ...totals, floorId, productId: editedFields.productId }).unwrap(), {
      pending: "Saving changes",
      success: "Product updated successfully",
      error: "Failed to update product",
    });
    setShow(false);
  };

  return (
    <td className={`${tdClass} actions-align`}>
      <img src={pencil} className="actions-align" alt={"pencil-icon"} onClick={() => setShow(true)} />
      {show && (
        <Modal
          title="Edit Material Data"
          saveButtonText="Save"
          closeButtonText="Cancel"
          handleSave={handleSave}
          handleCancel={() => setShow(false)}
          rootClass="transparent-backdrop"
          isSaveBtnDisabled={!editedFields.quantity || editedFields.price === ""}
          size="lg"
          bodyClass="scroll-bar"
        >
          <form className="search-form-container__fields__form">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 search-form-container__fields__form-group">
                <InputField
                  type="text"
                  label="Product Name"
                  id="productName"
                  fieldClasses="form-control search-form-container__fields__form-group__item"
                  value={editedFields.productName}
                  onChange={(e) => setEditedFields({ ...editedFields, productName: e.target.value })}
                />
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 search-form-container__fields__form-group">
                <InputField
                  type="number"
                  label="Quantity"
                  id="quantity"
                  fieldClasses="form-control search-form-container__fields__form-group__item"
                  value={editedFields.quantity}
                  onChange={(e) =>
                    setEditedFields({
                      ...editedFields,
                      quantity: e.target.value === "" ? "" : Math.round(e.target.value * 100) / 100,
                    })
                  }
                />
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 search-form-container__fields__form-group">
                <InputField
                  type="number"
                  label="Unit Price"
                  id="price"
                  fieldClasses="form-control search-form-container__fields__form-group__item"
                  value={editedFields.price}
                  onChange={(e) =>
                    setEditedFields({
                      ...editedFields,
                      price: e.target.value === "" ? "" : Math.round(Math.max(e.target.value, 0) * 100) / 100,
                    })
                  }
                />
              </div>
            </div>
          </form>
        </Modal>
      )}
    </td>
  );
};

export default ProductEditModal;
